import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { maxIndex, minIndex } from 'd3-array';
import { columnOf } from './utils/helper';
import { createGroups } from './utils/order';
function first(I, V) {
  return [I[0]];
}
function last(I, V) {
  var i = I.length - 1;
  return [I[i]];
}
function max(I, V) {
  var i = maxIndex(I, function (i) {
    return V[i];
  });
  return [I[i]];
}
function min(I, V) {
  var i = minIndex(I, function (i) {
    return V[i];
  });
  return [I[i]];
}
function normalizeSelector(selector) {
  if (typeof selector === 'function') return selector;
  var registry = {
    first: first,
    last: last,
    max: max,
    min: min
  };
  return registry[selector] || first;
}
/**
 * The select transform groups marks with specified channels, and
 * filter index by specified selector for each series, say to
 * pull a single or multiple values out of each series.
 */
export var Select = function Select() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? 'series' : _options$groupBy,
    channel = options.channel,
    selector = options.selector;
  return function (I, mark) {
    var encode = mark.encode;
    var groups = createGroups(groupBy, I, mark);
    var _columnOf = columnOf(encode, channel),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      V = _columnOf2[0];
    var selectFunction = normalizeSelector(selector);
    return [groups.flatMap(function (GI) {
      return selectFunction(GI, V);
    }), mark];
  };
};
Select.props = {};